module.exports = __webpack_public_path__ + "img/Асептический некроз мыщелков  бедренной или большеберцовой кости.d56a28a1.jpg";